import { UseToastOptions, useToast } from "@chakra-ui/react";
import { useCallback } from "react";

interface UseCustomToast {
  showShortToast: (
    title: string,
    status: UseToastOptions["status"],
    duration?: number,
    isClosable?: boolean
  ) => void;
}

export const useCustomToast = (): UseCustomToast => {
  const toast = useToast();

  const showShortToast = useCallback(
    (title: string, status: UseToastOptions["status"], duration?: number, isClosable?: boolean) => {
      toast({
        title,
        status,
        duration: duration || 10000, // 10s
        isClosable: isClosable || true
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return {
    showShortToast
  };
};
